import gql from 'graphql-tag';

// Dev note: If this is changed you likely need to update `PageStatusQuery` in view-page-common
export const PageStatusQuery = gql`
	query PreloadPageStatusQuery($contentId: ID!) {
		content(id: $contentId, status: ["archived", "current"]) {
			nodes {
				id
				status
			}
		}
	}
`;
